 export default {
  props: {
    value: {
      required: true
    },
    bindByArray: {
      type: Boolean,
      default: false
    },
    val: {
      required: false
    }
  },
  computed: {
    localValue: {
      get() {
        if (this.bindByArray) {
          return this.value.includes(this.val);
        } else {
          return this.value;
        }
      },
      set(newVal): void {
        if (this.bindByArray) {
          const index = this.value.indexOf(this.val);
          let newArray = this.value.slice();
          if (index !== -1) {
            newArray.splice(index, 1);
          } else {
            newArray.push(this.val);
          }
          this.$emit('input', newArray);
        } else {
          this.$emit('input', newVal);
        }
      }
    }
  }
};